/** @module Camunda/ProcessOnInstanceTaskRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/card/AttributeCardRenderer",
	"csi/locale",
	"csi/core/Key",
	"csi/task/TaskDueDateRenderer",
	"csi/task/util",
	"csi/core/SpecBuilder",
	"csi/widget/MaterialIcon",
	"./main",
	"./PriorityIconOnTaskRenderer",
], function(declare, _, AttributeCardRenderer, locale, Key, TaskDueDateRenderer, TaskUtil, SpecBuilder, MaterialIcon, Camunda, PriorityIconOnTaskRenderer) {

	const _DueDateRenderer = declare(TaskDueDateRenderer, {
		/**
		 * @override
		 * Render icon if completed
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const node = ctx.getNode();
			if (TaskUtil.isTaskActive(node)) {
				return this.inherited(arguments);
			}
			const state = node.ActivityState;
			new MaterialIcon({
				icon: (state == Camunda.STATE_COMPLETED) ? "check_circle" : "cancel"
			}).placeAt(refNode);

			return true;
		}
	});

	return declare(AttributeCardRenderer, {
		/**
		 * @override
		 * Specify anchor href and text for attribute card
		 */
		onAttributeCardParams: function(ctx, params) {
			const {queryResult} = ctx;
			const specBuilder = new SpecBuilder("CamundaTask");

			params.hideImage = true;

			params.anchorText = locale.getNodeName(ctx.getNode(), ctx.cache);
			params.onClick = function() {
				_.defer(function() {
					ctx.view.set("filmstripSelection", queryResult.id);
				});
			};

			params.attributeSpecs = [
				specBuilder.getSpecForKey(new Key({id: "Assignee"}))
			]

			params.upperRightSpec = specBuilder.getSpecForKey(new Key({id: "DueDate"}));
			params.upperRightSpec.heading.classRenderer = _DueDateRenderer;
			params.bottomRightSpec = specBuilder.getSpecForKey(new Key({id: "Priority"}));
			params.bottomRightSpec.heading.classRenderer = PriorityIconOnTaskRenderer;
		},

		/**
		 * @override
		 * There is no details card for task in process instance view
		 */
		toTooltip: function(ctx, h, tooltip) { }
	});
});
